import React from 'react';
import { Link } from 'react-router-dom';
import CSSTransition from 'react-transition-group/CSSTransition';
import { useRouter } from '../../hooks';
import BottomBar from '../Header/BottomBar';
import styles from './SideMenu.module.css';

const SideMenu = () => {
  const router = useRouter();
  const menu = [
    {
      name: 'Movies',
      path: '/movies',
    },
    {
      name: 'Series',
      path: '/series',
    },
    {
      name: 'Animation',
      path: '/animation',
    },
  ];

  return (
    <>
      <div className={`${styles['side-menu-wrapper']} show-mobile`}>
        <ul className={styles['side-menu']}>
          {menu?.map((item) => {
            const selected = router?.location?.pathname === item.path;
            return (
              <li
                key={item.name}
                className={selected ? styles['selected'] : ''}
              >
                <Link to={item.path}>{item.name}</Link>
              </li>
            );
          })}
        </ul>
      </div>
    </>
  );
};

export default SideMenu;
